








































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import {
  FOUNDER_CONSULT,
  CONST_FOUNDER_CONSULT,
  GENDER,
  CONST_GENDER,
  SPACE_TYPE,
  PaginationCount,
  CONST_PAGINATION_COUNT,
} from '../../../services/shared';
import { CodeManagementDto } from '../../../services/init/dto';

import AdminService from '../../../services/admin.service';
import CompanyService from '../../../services/company.service';
import CodeManagementService from '../../../services/code-management.service';
import FounderConsultService from '../../../services/founder-consult.service';
import SpaceTypeService from '../../../services/space-type.service';

import { getStatusColor } from '../../../core/utils/status-color.util';

import {
  AdminDto,
  FounderConsultListDto,
  CompanyDto,
  FounderConsultDto,
  SpaceTypeDto,
} from '../../../dto';
import {
  Pagination,
  CONST_OBJECT_BY_VALUE,
  OrderByValue,
  YN,
  CONST_YN,
} from '../../../common';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { Environment } from '../../../../environments';

const env = new Environment();

@Component({
  name: 'FounderConsultList',
})
export default class FounderConsult extends BaseComponent {
  private founderConsultSearchDto = new FounderConsultListDto();
  private founderConsultList: FounderConsultDto[] = [];
  private founderConsultTotalCount = null;
  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];

  private founderConsultStatusSelect: CodeManagementDto[] = [];
  private availableTimesSelect: CodeManagementDto[] = [];
  private companySelect: CompanyDto[] = [];
  private totalPage = 0;
  private delYn: YN[] = [...CONST_YN];
  private genderSelect: GENDER[] = [...CONST_GENDER];
  private spaceTypeSelect: SpaceTypeDto[] = [];
  private pagination = new Pagination();
  private dataLoading = false;
  private newDate = new Date();
  private adminList: AdminDto[] = [];

  private fields = {
    이름: 'nanudaUser.name',
    연락처: 'nanudaUser.phone',
    성별: 'nanudaUser.genderInfo.value',
    상담시간: 'availableTime.value',
    신청일: 'createdAt',
    창업경험: 'changUpExpYn',
    신청상태: 'codeManagement.value',
    점포명: 'space.name',
    주소: 'space.address',
    비고: 'spaceConsultEtc',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  // get status color
  getStatusColor(status: FOUNDER_CONSULT) {
    return getStatusColor(status);
  }

  getMoreConsultEtc(consultNo) {
    return `more_etc_${consultNo}`;
  }

  findAdmin() {
    AdminService.findForSelect().subscribe(res => {
      if (res) {
        this.adminList = res.data;
      }
    });
  }

  // 상태값
  getFounderConsultCodes() {
    CodeManagementService.findCodesFounderConsult().subscribe(res => {
      this.founderConsultStatusSelect = res.data;
    });
  }

  // 희망시간대
  getAvailableTimes() {
    CodeManagementService.findAvailableTimes().subscribe(res => {
      this.availableTimesSelect = res.data;
    });
  }

  // TODO: Create autocomplete box
  getCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  getSpaceTypes() {
    SpaceTypeService.findForSelect().subscribe(res => {
      this.spaceTypeSelect = res.data;
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  // 검색하기
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.founderConsultSearchDto.spaceTypeNo = SPACE_TYPE.SPACE_SHARE;
    this.dataLoading = true;
    this.pagination.limit = this.newLimit;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.founderConsultSearchDto, this.pagination);
    }
    FounderConsultService.findAll(
      this.founderConsultSearchDto,
      this.pagination,
    ).subscribe(res => {
      this.dataLoading = false;
      this.founderConsultList = res.data.items;
      this.founderConsultTotalCount = res.data.totalCount;
    });
  }

  // 초기화
  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.founderConsultSearchDto = new FounderConsultListDto();
      this.findAll();
    }
  }

  created() {
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.founderConsultSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.newLimit = +query.limit;
        // this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }

    this.getAvailableTimes();
    this.getCompanies();
    this.getFounderConsultCodes();
    this.getSpaceTypes();
    this.findAdmin();
  }
}
